import { di } from 'react-magnetic-di';
import type { StoreActionApi } from 'react-sweet-state';

import type { ScreenTabsChangesPublic } from '../../../../common/types/screen-tabs';
import type { AppId, ChangeId, IssueAdjustmentsState } from '../../types';
import { UiModificationsScreenTabsValidationError } from '../../utils/errors/ui-modifications-screentabs-validation-error';
import { toScreenTabsValidationError } from '../../utils/errors/utils';
import { collectScreenTabsAppliedChangesHistory } from '../applied-changes-history/collect-history';

import {
	getScreenTabsPublicToInternalValidationErrors,
	screenTabsPublicToInternalTransformer,
	screenTabsPublicToInternalValidator,
} from './utils';

type ProcessIframeScreenTabsChangesPayload = {
	screenTabsChanges: ScreenTabsChangesPublic;
	appId: AppId;
	changeId: ChangeId;
};

/**
 * Update screen tabs store data from changes coming from UI Modifications
 */
export const updateScreenTabs =
	({
		screenTabsChanges: screenTabsFromIframe,
		changeId,
		appId,
	}: ProcessIframeScreenTabsChangesPayload) =>
	({ getState, setState, dispatch }: StoreActionApi<IssueAdjustmentsState>): void => {
		di(collectScreenTabsAppliedChangesHistory, getScreenTabsPublicToInternalValidationErrors);

		const { screenTabs: internalScreenTabs } = getState();
		// If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
		if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) {
			return;
		}

		if (
			internalScreenTabs &&
			screenTabsPublicToInternalValidator(internalScreenTabs, screenTabsFromIframe)
		) {
			const newScreenTabs = screenTabsPublicToInternalTransformer(
				internalScreenTabs,
				screenTabsFromIframe,
			);

			setState({ screenTabs: newScreenTabs });

			dispatch(
				collectScreenTabsAppliedChangesHistory({
					appId,
					changeId,
					screenTabs: newScreenTabs,
				}),
			);
		} else {
			throw new UiModificationsScreenTabsValidationError('Transformation failed', {
				errors: getScreenTabsPublicToInternalValidationErrors(
					internalScreenTabs,
					screenTabsFromIframe,
				).map(toScreenTabsValidationError),
			});
		}
	};
